import { put, select, apply } from 'redux-saga/effects';
import { errorNotification, successNotification } from '../reducers/notification.reducers';
import {
  finishPrintOrder,
  printOrderFailed as printFailedAction,
  startPrintOrder,
  reconnectPrinter as reconnectPrinterAction,
  reconnectPrinterFinished as reconnectPrinterFinishedAction
} from '../reducers/order.reducers';
import moment from 'moment';


import EPosPrinter from '../utils/epos-printer';

export function* initPrinter(orderApi, { payload }) {

  if ((yield select(state => state.app.localSettings.useEposPrinter)) == true) {

    let ipAddress = payload && payload.ipAddress ? payload.ipAddress : yield select(state => state.app.localSettings.ePosPrinterIP);
    let port = payload && payload.port ? payload.ipAddress : yield select(state => state.app.localSettings.ePosPrinterPort);

    const response = yield EPosPrinter.connect(ipAddress, port);

    if (response === "success") {
      yield put(successNotification("Connected to ePosPrinter"));
      yield printOustandingOrders();
    } else {
      yield put(reconnectPrinterAction());
    }

  } else {
    console.log("ePosPrinter is currently not activated in localSettings")
  }
}

export function* initPrinterFailed() {
  yield put(errorNotification('Failed to connect to ePosPrinter'));
}

export function* printArticleList(orderApi, { payload }) {
  const articlelist = payload;

  console.log("started printing articlelist");

  try {
    const printResult = yield EPosPrinter.printArticleList(articlelist);
    console.log("Printresult:");
    console.log(printResult);

    if (printResult === "success") {
      //finish print
      //yield put(finishPrintOrder(order));
    } else {
      console.log("printing failed")
      yield put(printFailedAction());
    }
  }
  catch (e) {
    console.log(e);
    if (e === "EPosPrinter is currently disconnected") {
      yield put(printFailedAction());
    } else {
      yield put(errorNotification(e));
    }
  }
}

export function* printOrder(orderApi, { payload }) {
  const order = payload;

  if ((yield select(state => state.app.localSettings.printViaService)) === true) {
    yield apply(orderApi, orderApi.printOrder, [order.id, 'receipt']);
  }

  if ((yield select(state => state.app.localSettings.useEposPrinter)) !== true) {
    yield put(finishPrintOrder(order));
    return;
  }

  console.log("started printing:")
  console.log(order)

  let head = new Map();

  if (!order.pickupTimeIsSet && order.spotName) {
    //Tischbestellung
    head.set("Tisch:", order.spotName);
  } else {
    //Lieferung oder Abholung
    head.set(order.isDelivery ? 'Lieferung an:' : 'Abholer:', order.pickupName);

    head.set("Bestellcode:", order.pickupCode);

    if (order.telephone)
      head.set("Telefon:", order.telephone);

    const pickupDate = moment().diff(moment(order.pickupDate, 'DD.MM.YYYY'), 'days') !== 0 ? " - " + order.pickupDate : "";

    if (order.pickupTimeIsSet)
      head.set(order.isDelivery ? 'Lieferzeit:' : 'Abholzeit:', order.pickupTime + pickupDate);
  }

  const orderDate = moment().diff(moment(order.orderDate, 'DD.MM.YYYY'), 'days') !== 0 ? " - " + order.orderDate : "";

  head.set('Bestellzeit:', order.orderTime + orderDate);

  if (order.address) {
    let { address } = order;
    if (address.companyName)
      head.set("Firma:", address.companyName)
    if (address.street)
      head.set("Straße:", address.street)
    if (address.city)
      head.set("Stadt:", address.zip + " " + address.city)
    if (address.stairway)
      head.set("Stiege:", address.stairway)
    if (address.floor)
      head.set("Stock:", address.floor)
    if (address.door)
      head.set("Tür:", address.door)
  }

  if (order.userNote) {
    head.set("Anmerkung:", order.userNote)
  }

  const localSettings = yield select(state => state.app.localSettings);

  let options = {
    printArticlePrice: localSettings.printArticlePrice,
    printTotalPrice: localSettings.printTotalPrice,
  }

  try {
    const printResult = yield EPosPrinter.printOrder(head, order.articles, options)
    console.log("Printresult:");
    console.log(printResult);

    if (printResult === "success") {
      //finish print
      yield put(finishPrintOrder(order));
    } else {
      console.log("printing failed")
      yield put(printFailedAction());
    }
  }
  catch (e) {
    console.log(e);
    if (e === "EPosPrinter is currently disconnected") {
      yield put(printFailedAction());
    } else {
      yield put(errorNotification(e));
    }
  }
}

function* printOustandingOrders() {
  const printingorders = yield select(state => state.orders.printingorders);
  const ordersToPrint = (yield select(state => state.orders.orders)).filter(item => printingorders[item.id]);

  for (let order of ordersToPrint) {

    console.log("reprinting: OrderID: " + order.id);
    yield put(startPrintOrder(order));

  }
}

export function* reconnect() {
  yield put(errorNotification("Reconnecting to ePosPrinter"));

  if ((yield select(state => state.app.localSettings.useEposPrinter)) === true) {
    const ipAddress = yield select(state => state.app.localSettings.ePosPrinterIP);
    const port = yield select(state => state.app.localSettings.ePosPrinterPort);

    const response = yield EPosPrinter.connect(ipAddress, port);

    if (response === "success") {
      yield put(reconnectPrinterFinishedAction());

      yield printOustandingOrders();

    } else {
      console.log("failed to connect to printer");

      console.log("started waiting")
      yield new Promise(r => setTimeout(r, 10000));
      console.log("finished waiting")

      yield put(reconnectPrinterAction());
    }

  } else {
    console.log("ePosPrinter is currently not activated in localSettings");
  }

}

export function* printFailed(orderApi) {
  yield put(errorNotification("Print failed. Reconnecting"));

  if ((yield select()).orders.reconnectingPrinter === false) {
    yield put(reconnectPrinterAction());
  }
}

export function* reconnectFinished() {
  yield put(successNotification("Successfully connected to ePosPrinter"));
}